import css from 'styled-jsx/css';
import { icons } from '../../config/styles';
import { svgToDataUri } from '../../utils/styles/svgMixins';

const PriceValidityStyles = css`
  .price-validity-wrapper {
    color: #333;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    width: fit-content;
    border-bottom: 1px solid #333;
    padding: 2px;
  }
  .open-validity-modal {
    cursor: pointer;
  }
  .modal-title {
    color: #333;
    font-size: 20px;
    font-weight: 400;
    line-height: 24px;
  }
  .accept-button {
    display: flex;
    align-self: flex-end;
    width: 145px;
  }
  .validity-modal-content {
    display: flex;
    flex-direction: column;
    gap: 24px;
    &.mobile {
      padding: 0 24px;
      .accept-button {
        display: contents;
      }
    }
  }
  .validity-list {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 16px;
    align-self: stretch;
  }
  .price-validity {
    display: flex;
    align-items: center;
    gap: 12px;
    align-self: stretch;
    color: #333;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
  }

  .icon-cmrPrice {
    background-image: url(${svgToDataUri(icons.cmrIconThumbnail)});
    width: 40px;
    flex-shrink: 0;
    height: 40px;
    background-repeat: no-repeat;
  }
  .icon-internetPrice,
  .icon-eventPrice {
    border-radius: 2.222px;
    flex-shrink: 0;
    background-image: url(${svgToDataUri(icons.cardThumbnail)});
    width: 40px;
    height: 40px;
    background-repeat: no-repeat;
  }
`;

export default PriceValidityStyles;
